import { render, staticRenderFns } from "./Nav.vue?vue&type=template&id=651686be&scoped=true"
import script from "./Nav.vue?vue&type=script&lang=js"
export * from "./Nav.vue?vue&type=script&lang=js"
import style0 from "./Nav.vue?vue&type=style&index=0&id=651686be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_5a3c64a85473ede7d9205802ebc6db0e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651686be",
  null
  
)

export default component.exports